import { v1 } from './v1';

export const onboarding = {
  v1,
};
